import { useTheme } from "@mui/material/styles";

export const HeaderLogo = (): React.ReactElement => {
  const theme = useTheme();

  return (
    <img
      style={{ width: 60, height: 32 }}
      src={theme.palette.mode === "dark" ? "assets/sans-ondemand-dark.png" : "assets/sans-ondemand.png"}
      alt={"SANS OnDemand logo"}
    />
  );
};
